const translations = {
    requiredField: {
        uk: 'Заповніть поле',
        ru: 'Заполните поле',
        en: 'Fill in the field',
        pl: 'Wypełnij pole',
        es: 'Rellene el campo'
    },
    minLengthTwo: {
        uk: 'Введіть більше 2-х букв',
        ru: 'Введите больше 2-х букв',
        en: 'Please enter more than 2 letters',
        pl: 'Wprowadź więcej niż 2 litery',
        es: 'Por favor ingrese más de 2 letras'
    },
    regexPhone: {
        uk: 'Заповніть поле в форматі +380 67 111-22-33',
        ru: 'Заполните поле в формате +380 67 111-22-33',
        en: 'Fill in the field in the format +380 67 111-22-33',
        pl: 'Wypełnij pole w formacie +380 67 111-22-33',
        es: 'Rellene el campo en el formato +380 67 111-22-33'
    },
    regexEmail: {
        uk: 'Заповніть поле в форматі email@mail.com',
        ru: 'Заполните поле в формате email@mail.com',
        en: 'Fill in the field in the format email@mail.com',
        pl: 'Wypełnij pole w formacie email@mail.com',
        es: 'Rellene el campo en el formato email@mail.com'
    },
    requiredPhone: {
        uk: 'Введіть мобільний телефон',
        ru: 'Введите мобильный телефон',
        en: 'Enter your mobile phone',
        pl: 'Wprowadź numer telefonu komórkowego',
        es: 'Ingrese su teléfono móvil'
    },
    requiredTelegram: {
        uk: 'Введіть обліковий запис Telegram',
        ru: 'Введите аккаунт Telegram',
        en: 'Enter your Telegram account',
        pl: 'Wprowadź konto Telegram',
        es: 'Ingrese su cuenta de Telegram'
    },
    startWithNumber: {
        uk: 'Почніть з цифри',
        ru: 'Начните с цифры',
        en: 'Start with a number',
        pl: 'Zacznij od liczby',
        es: 'Comience con un número'
    },
    enterNumber: {
        uk: 'Введіть цифру',
        ru: 'Введите цифру',
        en: 'Enter a number',
        pl: 'Wprowadź liczbę',
        es: 'Ingrese un número'
    },
    minLengthThree: {
        uk: 'Введіть більше 3-х літер',
        ru: 'Введите больше 3-х букв',
        en: 'Please enter more than 3 letters',
        pl: 'Wprowadź więcej niż 3 litery',
        es: 'Por favor ingrese más de 3 letras'
    },
    goToPayment: {
        uk: 'Перейти до оплати',
        ru: 'Перейти к оплате',
        en: 'Proceed to checkout',
        pl: 'Przejdź do płatności',
        es: 'Continuar con el pago'
    },
    checkout: {
        uk: 'Оформити замовлення',
        ru: 'Оформить заказ',
        en: 'Checkout',
        pl: 'Złóż zamówienie',
        es: 'Finalizar compra'
    },
    regexString: {
        uk: 'Використовуйте букви і дефіс',
        ru: 'Используйте буквы и дефис',
        en: 'Use letters and hyphens',
        pl: 'Używaj liter i myślników',
        es: 'Utilice letras y guiones'
    },
    chooseAdress: {
        uk: 'Виберіть населений пункт зі списку',
        ru: 'Выберите населенный пункт из списка',
        en: 'Choose city from the list',
        pl: 'Wybierz rozliczenie z listy',
        es: 'Elija la ciudad de la lista'
    },
    chooseMailbox: {
        uk: 'Виберіть поштомат зі списку',
        ru: 'Выберите поштомат из списка',
        en: 'Choose mailbox from the list',
        pl: 'Wybierz urządzenie pocztowe z listy',
        es: 'Elija un buzón de la lista'
    },
    chooseOffice: {
        uk: 'Виберіть поштове відділення зі списку',
        ru: 'Выберите почтовое отделение из списка',
        en: 'Choose post office from the list',
        pl: 'Wybierz urząd pocztowy z listy',
        es: 'Elija una oficina de correos de la lista'
    },
    chooseStreet: {
        uk: 'Виберіть вулицю зі списку',
        ru: 'Выберите улицу из списка',
        en: 'Choose street from the list',
        pl: 'Wybierz ulicę z listy',
        es: 'Elija una calle de la lista'
    },
    promocodeTotal: {
        uk: 'РАЗОМ',
        ru: 'ИТОГ',
        en: 'TOTAL',
        pl: 'RAZEM',
        es: 'TOTAL'
    },
    ingredientsOpener : {
        uk: 'Читати більше',
        ru: 'Читать подробнее',
        en: 'Read more',
        pl: 'Czytaj więcej',
        es: 'Seguir leyendo'
    },
    ingredientsClose : {
        uk: 'Згорнути',
        ru: 'Свернуть',
        en: 'Collapse',
        pl: 'Zawalić się',
        es: 'Colapsar'
    },
    notEnoughStock: {
        uk: 'Недостатньо товару на складі',
        ru: 'Недостаточно товара на складе',
        en: 'Not enough items in stock',
        pl: 'Niewystarczająca ilość w magazynie',
        es: 'No hay suficiente stock'
    },
    maxStockOnly: {
        uk: 'Доступно лише {0} шт',
        ru: 'Доступно только {0} шт',
        en: 'Only {0} item(s) available',
        pl: 'Dostępne tylko {0} szt',
        es: 'Solo hay {0} unidad(es) disponibles'
    }
};

export default translations;
